import { styled } from '@mui/material';
import { omitForwardedProps } from 'common/utils';

type Props = {
  open: boolean;
};

export const MainContainer = styled('div', {
  name: 'MainContainer',
  shouldForwardProp: omitForwardedProps<Props>('open'),
})<Props>(({ theme: { transitions, breakpoints }, open }) => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  // A flex item's min-width defaults to its min-content width, so any unbreakable content (a
  // `nowrap` line, a wide table) would widen the whole main column past the viewport instead of
  // being contained by it. Pin it so the layout column can always shrink to the window (HNS-340).
  minWidth: 0,
  transition: transitions.create('margin', {
    easing: transitions.easing.sharp,
    duration: transitions.duration.leavingScreen,
  }),
  ...(open && {
    transition: transitions.create('margin', {
      easing: transitions.easing.easeOut,
      duration: transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  }),
  [breakpoints.down('sm')]: {
    marginLeft: 0,
  },
}));
